// extracted by mini-css-extract-plugin
module.exports = {"floatingCTA":"FloatingCTA-module--floatingCTA--1rxZ3","text":"FloatingCTA-module--text--2ft_U","button":"FloatingCTA-module--button--1onof"};